import type {DesignSelection} from '@Components/social-media/social-media.types';

export const MAX_UPLOADS_TO_DESIGNS = 10;

export interface WizardUploadMediaGa4Callbacks {
  onTriggered: () => void;
  onPosterCreated: () => void;
}

export interface WizardUploadDesignsCallbacks extends Partial<WizardUploadMediaGa4Callbacks> {
  onDesignsCreated: (designs: DesignSelection[]) => void;
  onPosterCreationsStarted?: () => void;
  /** Defaults to the upload cap; the wizard narrows it to what the user's plan still allows. */
  maxSelectionNumber?: number;
}
